import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  standalone: false,
})
export class PaginatorComponent {
  @Input({ required: true }) pageSize!: number;
  @Input({ required: true }) pageNumber!: number;
  @Input({ required: true }) totalRecords!: number;

  @Output() pageChanged = new EventEmitter<number>();

  startIndex(): number {
    if (!this.pageNumber || !this.pageSize) {
      return 0;
    }

    return this.pageSize * (this.pageNumber - 1) + 1;
  }

  endIndex(): number {
    if (!this.pageNumber || !this.pageSize) {
      return 0;
    }

    const endIndex = this.pageSize * this.pageNumber;
    if (endIndex > this.totalRecords) {
      return this.totalRecords;
    }

    return endIndex;
  }

  nextPage() {
    this.pageChanged.emit(this.pageNumber + 1);
  }

  previousPage() {
    this.pageChanged.emit(this.pageNumber - 1);
  }
}
